import React, { Component, lazy, Suspense } from 'react';
import { createHashHistory } from 'history';
import { Switch } from "react-router-dom";
import { Route } from "react-router-dom";
import Auth from "../../../../Layout/Auth";

const TemplatePage = lazy(() => import('../Pages/TemplatePage'))
class TemplateRoute extends Component {
  render() {
    const history = createHashHistory();
    return (
      <Switch>
        <Route
          exact
          path="/:lng/template"
          render={() => (
            <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
              <Suspense fallback={<Loading />}>
                <TemplatePage history={history} location={location} />
              </Suspense>
            </Auth>
          )}
        />
      </Switch>
    );
  }
}
export default TemplateRoute;

function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading...</span>
      </div>
    </>
  );
}
